// Player Archetype library — loaded once from GET /api/dev/archetype-library (backed by backend/data/development_inventory_archetypes.csv).
import { useEffect, useState } from "react";
import axios from "axios";

let ITEMS = [];
let META = { version: "", synced_at: null, active: 0 };
let loader = null;
export const ARCHETYPE_BY_ID = {};

export function loadArchetypeLibrary() {
  if (!loader) {
    loader = axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/dev/archetype-library`).then(r => {
      ITEMS = r.data.archetypes || [];
      META = { version: r.data.version || "", synced_at: r.data.synced_at || null, active: r.data.active || 0 };
      Object.keys(ARCHETYPE_BY_ID).forEach(k => delete ARCHETYPE_BY_ID[k]);
      ITEMS.forEach(a => { ARCHETYPE_BY_ID[a.id] = a; });
      return ITEMS;
    }).catch(e => { loader = null; throw e; });
  }
  return loader;
}

export function useArchetypeLibrary() {
  const [state, setState] = useState({ ready: ITEMS.length > 0, meta: META, error: null });
  useEffect(() => {
    let live = true;
    loadArchetypeLibrary().then(() => live && setState({ ready: true, meta: META, error: null }))
      .catch(() => live && setState({ ready: false, meta: META, error: "Could not load the archetype library" }));
    return () => { live = false; };
  }, []);
  return state;
}

export const SIDES = [["offense", "Offense"], ["defense", "Defense"]];
export const SIDE_COLOR = { offense: "#f0a35b", defense: "#5b8ff0" };
export const getArchetype = (id) => (id ? ARCHETYPE_BY_ID[id] || { id, name: id, description: "", status: "legacy", side: null, group: "Legacy", keySkillIds: [], canBeSecondary: true, cantPairWith: [] } : null);
// Active archetypes for a side (file order), plus any retired one already chosen so old picks stay visible.
export const archetypesFor = (side, chosenIds = []) => ITEMS.filter(a => a.side === side && (a.status === "active" || chosenIds.includes(a.id)));
export const groupsFor = (side, chosenIds) => [...new Set(archetypesFor(side, chosenIds).map(a => a.group))];

// Why `candidate` can't be the Secondary for `primary` (null = allowed).
export function secondaryBlockReason(primaryId, candidate) {
  const p = primaryId ? ARCHETYPE_BY_ID[primaryId] : null;
  if (!p) return "Pick a Primary first.";
  if (candidate.id === p.id) return "Already the Primary.";
  if (!candidate.canBeSecondary) return `${candidate.name} can only be a Primary.`;
  if (p.cantPairWith === "ALL") return `${p.name} doesn't take a Secondary.`;
  if (candidate.cantPairWith === "ALL" || p.cantPairWith.includes(candidate.id) || (candidate.cantPairWith || []).includes(p.id)) return `Can't pair with ${p.name}: pick the one that fits better.`;
  return null;
}

export const archetypeLine = (side, sel) => {
  const p = getArchetype(sel?.primary), s = getArchetype(sel?.secondary);
  return p ? `${p.name}${s ? ` / ${s.name}` : ""}` : "";
};
